// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as config from '../../auth_config.json';
import { APP_VERSION } from './version';

const { domain, clientId, audience, apiUri, errorPath } = config as {
  domain: string;
  clientId: string;
  audience?: string;
  apiUri: string;
  errorPath: string;
};

const enum ConfigHost {
  GBOP = 0,
  HUNT = 1,
  RunPayroll = 2,
  SURE = 3,
  MYOB = 4,
  PXGO = 5,
}

const enum ConfigProperty {
  DomainName = 0,
  ClientId = 1,
  MfaAuthority = 2,
}

const configHostNames: string[] = [
  // index matches [ConfigHost enum]
  'businessonlinepayroll.com',
  'ht.businessonlinepayroll.com',
  'runpayroll.com',
  '.surepayroll.com',
  'accountedge.surepayroll.com',
  '.paychex.com',
];

const configKeys: string[][] = [
  // index matches [ConfigHost enum][ConfigProperty]
  [
    '^#BUSINESSONLINEPAYROLL_IDENTITY_AUTHORITY#^',
    '^#BUSINESSONLINEPAYROLL_ESS_CLIENTID#^',
    '^#BUSINESSONLINEPAYROLL_IDENTITY_OAUTH_AUTHORITY#^',
  ],
  [
    '^#BUSINESSONLINEPAYROLL_IDENTITY_AUTHORITY#^',
    '^#BUSINESSONLINEPAYROLL_IDENTITY_HUNT_ESS_CLIENTID#^',
    '^#BUSINESSONLINEPAYROLL_IDENTITY_OAUTH_AUTHORITY#^',
  ],
  [
    '^#RUNPAYROLL_IDENTITY_AUTHORITY#^',
    '^#RUNPAYROLL_IDENTITY_ESS_CLIENTID#^',
    '^#RUNPAYROLL_IDENTITY_OAUTH_AUTHORITY#^',
  ],
  [
    '^#SUREPAYROLL_IDENTITY_AUTHORITY#^',
    '^#SUREPAYROLL_IDENTITY_ESS_CLIENTID#^',
    '^#SUREPAYROLL_IDENTITY_OAUTH_AUTHORITY#^',
  ],
  [
    '^#SUREPAYROLL_IDENTITY_AUTHORITY#^',
    '^#SUREPAYROLL_IDENTITY_MYOB_ESS_CLIENTID#^',
    '^#SUREPAYROLL_IDENTITY_OAUTH_AUTHORITY#^',
  ],
  [
    '^#PAYCHEX_IDENTITY_AUTHORITY#^',
    '^#PAYCHEX_IDENTITY_ESS_CLIENTID#^',
    '^#PAYCHEX_IDENTITY_OAUTH_AUTHORITY#^',
  ],
];

const configResolved = resolveConfigs();

export const environment = {
  name: 'deploy',
  env: '^#ENVIRONMENT_NAME#^',
  production: false,
  baseUrl: '^#pxAPIRoot#^',
  auth: {
    domain: configResolved.DomainName.substring(8), //'^#SUREPAYROLL_IDENTITY_AUTHORITY#^'.substring(8)

    clientId: configResolved.ClientId, //'^#SUREPAYROLL_IDENTITY_ESS_CLIENTID#^',
    ...(audience && audience !== 'YOUR_API_IDENTIFIER' ? { audience } : null),
    redirectUri: window.location.origin + '/ess',
    errorPath,
  },

  usernameEditProgramCodeBlacklist: [
    'CITB',
    'FRAN',
    'HCON',
    'MLIN',
    'MNIS',
    'MYOB',
    'NATC',
    'NCEM',
    'NRTH',
    'SFTA',
    'SOCR',
    'SURE',
    'TEST',
    'UBOC',
    'WF',
  ],
  httpInterceptor: {
    allowedList: ['^#pxAPIRoot#^/*'],
  },
  audienceMfa: configResolved.MfaAuthority, // 'https://^#SUREPAYROLL_IDENTITY_OAUTH_AUTHORITY#^/mfa/',
  kongApiKey: '^#KONG_ESS_API_KEY#^',
  subDomainSuffix: '^#SUB_DOMAIN_SUFFIX_ESS#^',
  thirdPartyConfigs: {
    pendoEnabled: true,
    sentryEnabled: true,
    googleTagManagerEnabled: true,
  },
  version: APP_VERSION,
  sentryDsn: 'https://5876e70f5dddd1d7b17f2ab836fe5d95@o1303294.ingest.sentry.io/4504679471185920',
  pendoId: 'd69e1894-ee0d-4179-707f-b40ffa9bbdb9',
  googleTagManagerId: 'GTM-TWDZDRW',
  applicationInsights: {
    enabled: true,
    connectionString: '^#APPLICATION_INSIGHTS_CONNECTION_STRING#^',
    cloudRoleName: 'ESS',
  },
};

function resolveConfigs() {
  let configHostIndex = -1;

  //NOTE: Order matters, e.g. HUNT host contains GBOP host
  if (window.location.hostname.includes(configHostNames[ConfigHost.HUNT])) {
    configHostIndex = ConfigHost.HUNT;
  } else if (window.location.hostname.includes(configHostNames[ConfigHost.GBOP])) {
    configHostIndex = ConfigHost.GBOP;
  } else if (window.location.hostname.includes(configHostNames[ConfigHost.RunPayroll])) {
    configHostIndex = ConfigHost.RunPayroll;
  } else if (window.location.hostname.includes(configHostNames[ConfigHost.PXGO])) {
    configHostIndex = ConfigHost.PXGO;
  } else if (window.location.hostname.includes(configHostNames[ConfigHost.MYOB])) {
    configHostIndex = ConfigHost.MYOB;
  } else {
    configHostIndex = ConfigHost.SURE;
  }

  const configResolved = {
    DomainName: configKeys[configHostIndex][ConfigProperty.DomainName],
    ClientId: configKeys[configHostIndex][ConfigProperty.ClientId],
    MfaAuthority: 'https://' + configKeys[configHostIndex][ConfigProperty.MfaAuthority] + '/mfa/',
  };

  console.log('Resolved Host name ' + configResolved.DomainName);
  console.log('Client id is ' + configResolved.ClientId);
  console.log('MFA Authority is ' + configResolved.MfaAuthority);

  return configResolved;
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
